/**
 * Deal Match Strategy
 *
 * How an email or a meeting was linked to a deal. Spans both streams, so it
 * lives in its own module rather than being owned by the meeting or email
 * types (it is NOT the same vocabulary as `MatchStrategy`, which is the
 * meeting-to-client link strategy in client.ts).
 *
 * Declaration order is the canonical order for value lists.
 */
export const DealMatchStrategy = {
    /** A participant is assigned to exactly one open deal. */
    CONTACT: 'contact',
    /** The email subject / meeting title matched the deal name. */
    KEYWORD: 'keyword',
    /** Legacy auto-link taken when the thread/client resolved to a single deal. */
    ONLY_DEAL: 'only_deal',
    /** A previous message in the same email thread was already linked. */
    THREAD: 'thread',
    /** More than one signal agreed (e.g. contact + subject). */
    MULTI_SIGNAL: 'multi_signal',
    /** A human linked it explicitly. */
    MANUAL: 'manual',
};
/** Runtime value list for consumers that need to validate or iterate (e.g. zod enums). */
export const DEAL_MATCH_STRATEGIES = Object.values(DealMatchStrategy);
